import { FormControl, FormHelperText, FormLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';


export default function CustomSelect2({ values, onChange, error, data, title, required, disabled, placeholder, subtitle, readOnly, name, valueName, labelName, height, iconName, startAdornment }) {
    return (
        <>
            <FormControl variant="outlined" fullWidth style={{}} >
                {title && <FormLabel style={{ fontFamily: 'FunnelSans', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>}
                <Select
                    size="small"
                    value={values}
                    name={name}
                    required={required}
                    disabled={disabled}
                    disableUnderline
                    displayEmpty
                    startAdornment={startAdornment}
                    placeholder={placeholder || 'Choose'}
                    onChange={(e) => onChange(e.target.value)}
                    style={{ color: (values === "" || values === "-1") && "#c8c8c8", height: height || 35, backgroundColor: 'white', borderRadius: 15, padding: 1, border: "1px solid #c4c4c4", fontWeight: 500, paddingInline: 15 }}
                    sx={{
                        ".MuiOutlinedInput-notchedOutline": { border: 0 },
                        "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                        {
                            border: 0,
                        },
                        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            border: 0,
                        },
                    }}
                    renderValue={(selected) => (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2, gap: '0px' }}>
                            <span style={{
                                fontSize: 12,
                                color: disabled ? '#C0C0C0' : '#808588',
                                fontWeight: 500,
                                marginBottom: 2
                            }}>
                                {selected && selected !== '-1' && title}
                                {/* {title} */}
                            </span>
                            <span style={{
                                fontSize: 14,
                                color: disabled ? '#C0C0C0' : (values === "" || values == "-1") ? "#BDBDBD" : 'inherit',
                                whiteSpace: 'nowrap'
                            }}>
                                {selected && selected !== '-1' ? data?.find((item) => item[valueName || 'value'] === selected)?.[labelName || 'label'] : placeholder}
                            </span>
                        </div>
                    )}
                    IconComponent={() => (
                        <i className={iconName || "ri-arrow-down-s-line mx-2"} style={{ zIndex: 2, color: "#c4c4c4" }} />
                    )}
                >
                    <MenuItem style={{ display: "none" }} key={"no-value"} value="-1" disabled>{placeholder}</MenuItem>
                    <MenuItem style={{ display: "none" }} key={"with-all-value"} value="all" disabled>{placeholder}</MenuItem>

                    {
                        data?.length > 0 ? data.map((x, idx) =>
                            <MenuItem key={idx}
                                value={x.value || x.id || x[`${valueName}`]}
                                style={{
                                    backgroundColor: (x.value || x.id) === values ? '#ED1A3D0D' : 'white',
                                    color: (x.value || x.id) === values ? '#ED1A3D' : '#101010'
                                }}
                            >
                                {x.label || x.name || x[`${labelName}`]}
                            </MenuItem>
                        ) :
                            <MenuItem disabled>No options available</MenuItem>
                    }
                </Select>
                <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}

        </>


    );
}
